import { render } from "./Podft.vue?vue&type=template&id=53103cc3"
import script from "./Podft.vue?vue&type=script&lang=js"
export * from "./Podft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__